"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLinePricingNote = void 0;
const dayjs = require("dayjs");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineEstimatedCheck_1 = require("./getOrderLineEstimatedCheck");
const hotel_1 = require("../hotel");
const getOrderLinePricingNote = (item) => {
    if (!item.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    const is_estimated = (0, getOrderLineEstimatedCheck_1.getOrderLineEstimatedCheck)(item);
    if (!latest_version)
        return null;
    switch (item.type) {
        case "GOLF": {
            return is_estimated
                ? {
                    estimated: true,
                }
                : null;
        }
        case "HOTEL": {
            const config = latest_version.config;
            // get me all the discounts on all the rooms
            const applicable_discounts = [];
            config.rooms.rooms.forEach((room) => {
                if (room.applied_discount) {
                    const applied_discount = (0, hotel_1.getFilteredRoomDiscounts)(config?.date_of_confirmation, config?.where_when_who?.check_in_date, (0, hotel_1.getApplicableDiscountsForRatePolicies)(room.rate, config?.where_when_who?.number_of_nights, dayjs(config?.where_when_who?.check_in_date).diff(dayjs(), "day")));
                    if (applied_discount)
                        applicable_discounts.push(applied_discount);
                }
            });
            // filter out all the applicable discounts where there is an early_bird discount
            if (applicable_discounts.length === 0) {
                return is_estimated
                    ? {
                        estimated: true,
                    }
                    : null;
            }
            // get best discount
            const best_discount = applicable_discounts?.reduce((acc, discount) => {
                // base it on the best.discount "%" discount
                if (discount.best &&
                    acc.best &&
                    discount.best.discount > acc.best.discount) {
                    return discount;
                }
                return acc;
            });
            if (best_discount.best && best_discount.best.type === "early_bird") {
                const early_bird_discounts = best_discount?.early_bird;
                // the early_bird_discounts array will have within them an early_bird_discounts array.  For each early_bird discount get the longest min_days_in_advance and then return the longest one across all the discounts
                if (early_bird_discounts) {
                    const longest_early_bird_discount = early_bird_discounts.find((discount) => discount.discount_percentage === best_discount?.best?.discount);
                    if (longest_early_bird_discount &&
                        (longest_early_bird_discount.min_days_in_advance ?? 0) > 0) {
                        return {
                            estimated: false,
                            text: "EB",
                            tooltip: `-${longest_early_bird_discount.discount_percentage}% Book by ${dayjs(config?.where_when_who?.check_in_date)
                                .subtract(longest_early_bird_discount.min_days_in_advance ?? 0, "day")
                                .format("DD MMM [']YY")}`,
                            colour: "#4CAF50",
                        };
                    }
                }
            }
            if (best_discount.best &&
                best_discount.best.type === "long_stay" &&
                best_discount.best.discount > 0) {
                return {
                    estimated: false,
                    text: "LS",
                    tooltip: `-${best_discount.best.discount}% Long Stay Discount`,
                    colour: "#4CAF50",
                };
            }
            if (best_discount.best &&
                best_discount.best.type === "early_bird_and_long_stay") {
                return {
                    estimated: false,
                    text: "EB+LS",
                    tooltip: `-${best_discount.best.discount}% Early Bird & Long Stay Discount`,
                    colour: "#4CAF50",
                };
            }
            return is_estimated
                ? {
                    estimated: true,
                }
                : null;
        }
        case "EXCURSION": {
            return is_estimated
                ? {
                    estimated: true,
                }
                : null;
        }
        case "TRANSFER": {
            return is_estimated
                ? {
                    estimated: true,
                }
                : null;
        }
        case "CUSTOM": {
            return is_estimated
                ? {
                    estimated: true,
                }
                : null;
        }
    }
};
exports.getOrderLinePricingNote = getOrderLinePricingNote;
